/**
 * BugGroupEntity Class file
 *
 * Generated file, don't touch manually
 *
 * ModelVersion: 90004
 */
import { BaseEntity } from "@archipad-js/core/orm";
import { BugWorkflowEntity } from "../BugWorkflowEntity";
import { BugStateEntity } from "../BugStateEntity";
import { VisitTypeEntity } from "../VisitTypeEntity";
import { ProjectUserRole_BugGroupsEntity } from "../ProjectUserRole_BugGroupsEntity";
import { Phase_BugGroupsEntity } from "../Phase_BugGroupsEntity";
import { BugEntity } from "../BugEntity";
import { ReportEntity } from "../ReportEntity";
import { BugGroupEntity } from "../BugGroupEntity";
declare global {
    interface EntityTypeMap {
        BugGroup: BugGroupEntity;
    }
}
export abstract class BugGroupGeneratedEntity extends BaseEntity {
    public abstract bugGroupId: string;
    public abstract templateName: string | null;
    public abstract templateId: string | null;
    public abstract name: string | null;
    public abstract bugWorkflow: BugWorkflowEntity;
    public abstract readonly bugStates: ReadonlyArray<BugStateEntity>;
    public abstract readonly visitTypes: ReadonlyArray<VisitTypeEntity>;
    public abstract readonly rolesRelations: ReadonlyArray<ProjectUserRole_BugGroupsEntity>;
    public abstract readonly phasesRelations: ReadonlyArray<Phase_BugGroupsEntity>;
    public abstract readonly bugs: ReadonlyArray<BugEntity>;
    public abstract readonly reports: ReadonlyArray<ReportEntity>;
}
